import { render, staticRenderFns } from "./BoardLineEmpty.vue?vue&type=template&id=a22f3c3a&"
import script from "./BoardLineEmpty.vue?vue&type=script&lang=js&"
export * from "./BoardLineEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports